<table class="table table-condensed table-wrapper-box">
    <tbody>
        <tr>
            <td width="40%" class="text-center">
                <strong>Nume</strong>
            </td>
            <td class="text-left">{{ spouse.nume + ' ' + spouse.prenume }}
            </td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Info CI/BI</strong>
            </td>
            <td class="text-left">{{ (spouse.ci_serie && spouse.ci_numar)
                ? (spouse.ci_serie + ' ' + spouse.ci_numar) : 'N/A' }}
            </td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>CNP</strong>
            </td>
            <td class="text-left">{{ spouse.cnp || 'N/A' }}</td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Nr. pașaport</strong>
            </td>
            <td class="text-left">{{ spouse.nr_pasaport || 'N/A' }}</td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Cetățenie</strong>
            </td>
            <td class="text-left">{{ spouse.cetatenie || 'N/A' }}</td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Competențe limba romană</strong>
            </td>
            <td class="text-left">{{ spouse.competenta_limba ? 'DA' : 'NU' }}</td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Nume dorit</strong>
            </td>
            <td class="text-left">{{ spouse.nume_dorit || 'N/A' }}</td>
        </tr>
        <tr *ngIf="spouse.tara">
            <td width="40%" class="text-center">
                <strong>Țară</strong>
            </td>
            <td class="text-left">{{ spouse.tara }}</td>
        </tr>
        <tr *ngIf="spouse.stat_provincie">
            <td width="40%" class="text-center">
                <strong>Stat/provincie</strong>
            </td>
            <td class="text-left">{{ spouse.stat_provincie }}</td>
        </tr>
        <tr *ngIf="spouse.judet">
            <td width="40%" class="text-center">
                <strong>Județ</strong>
            </td>
            <td class="text-left">{{ spouse.judet }}</td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Oraș</strong>
            </td>
            <td class="text-left">{{ spouse.oras || 'N/A' }}</td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Adresă</strong>
            </td>
            <td class="text-left">{{ spouse.adresa_text || 'N/A' }}</td>
        </tr>
        <tr>
            <td width="40%" class="text-center">
                <strong>Observații</strong>
            </td>
            <td class="text-left">{{ spouse.observatii || 'N/A' }}</td>
        </tr>
    </tbody>
</table>